import React, { Component } from 'react';
import Header from '../Component/Header';
import Sidebar from '../Component/Sidebar';
import Loader from '../Component/Loader';


class StripeReturn extends Component {

  componentDidMount = () => {
    let is_stripe_connect = localStorage.getItem('is_stripe_connect') || null;
    let temp_franchise = JSON.parse(localStorage.getItem('temp_franchise')) || null

    if (is_stripe_connect) {
      this.props.history.push(`/franchise/detail`, { query: temp_franchise });
    }
    else{
      this.props.history.push(`/franchise`);
    }
  }

  render() {
    return (
      <div id="wrapper">
        <div className="content-area">
          {/* Header */}
          <Header />

          {/* Sidebar */}
          <Sidebar history={this.props.history} />

          <div className="container">

          </div>
        </div>
        <Loader />
      </div>
    );
  }
}

export default StripeReturn;